import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import * as Sentry from '@sentry/react'
import { queryClient } from '@/lib/queryClient'
import { AuthProvider } from '@/hooks/useAuth'
import { router } from '@/lib/router'
import { theme } from '@/theme'
import { ToastProvider } from '@/hooks/useToast'
import { env } from '@/lib/env'

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
          <h2>Something went wrong</h2>
          <pre style={{ whiteSpace: 'pre-wrap', color: '#c00' }}>
            {(error as Error)?.message || 'Unknown error'}
          </pre>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>

            {/* Environment indicator - hidden in deployed production */}
            {(env.firebaseProjectId.includes('staging') ||
              import.meta.env.DEV) && (
              <div
                style={{
                  position: 'fixed',
                  bottom: 8,
                  right: 8,
                  zIndex: 9999,
                  backgroundColor: env.firebaseProjectId.includes('staging')
                    ? 'rgba(0,0,0,0.7)'
                    : 'rgba(180,0,0,0.8)',
                  color: '#fff',
                  padding: '4px 12px',
                  borderRadius: 4,
                  fontSize: '0.7rem',
                  fontFamily: 'monospace',
                  pointerEvents: 'none',
                  opacity: 0.85,
                }}
              >
                {env.firebaseProjectId.includes('staging')
                  ? 'STAGING'
                  : 'PRODUCTION'}
                {' | '}
                {env.firebaseProjectId}
                {env.useEmulator && ' | Emulator'}
              </div>
            )}
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}
